import type { JSONContent } from '@shared/models';
import { TextDto } from './text.dto';

export class Text {
    readonly id: string;
    readonly name: string;
    readonly type: string;
    readonly content: JSONContent | null;

    constructor(dto: TextDto) {
        this.id = dto.id;
        this.name = dto.name;
        this.type = dto.type;
        this.content = dto.content;
    }
}
